import { useEffect, useState } from 'react';
import Empty from 'components/Empty';
import { Button, Tag } from 'antd';
import style from './SearchStyle';
import { searchWordsCache } from 'services/cache';
import { useTranslate } from '@tolgee/react';

export type CacheWord =
  | string
  | {
      type: 'batch';
      searchType?: 'order' | 'track';
      word: string;
    };

function setLocalSearchWords(wordArr: CacheWord[]) {
  searchWordsCache.set(wordArr);
}
function getLocalSearchWords(): CacheWord[] {
  const s = searchWordsCache.get<CacheWord[]>();
  return s || [];
}

type SearchWordsProps = {
  showSearchHis: boolean;
  searchWord: string;
  isBatch?: boolean;
  searchType: string;
  doSearch: (searchStr?: CacheWord) => void;
};
export default function SearchWords({
  showSearchHis,
  searchWord,
  isBatch,
  searchType,
  doSearch,
}: SearchWordsProps) {
  const { t } = useTranslate();

  const [tagArr, setTagArr] = useState<CacheWord[]>(() => getLocalSearchWords());
  useEffect(() => {
    if (searchWord !== '') {
      const wordArr = [
        isBatch
          ? {
              type: 'batch' as const,
              searchType: searchType as any,
              word: searchWord,
            }
          : searchWord,
        ...tagArr.filter(
          (_) => _ !== searchWord && (typeof _ === 'string' || _.word !== searchWord),
        ),
      ].slice(0, 16);
      setTagArr(wordArr);
      setLocalSearchWords(wordArr);
    }
    // `tagArr`必须忽略依赖
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchWord, tagArr.length, isBatch, searchType]);

  return (
    <div className={`${style.recentSearchWrap} ${!showSearchHis ? style.hide : ''}`}>
      <div className={style.recentSearch}>
        <Button type="text" size="small" style={{ color: '#515359', cursor: 'default' }}>
          {t('scene.chatWorkspace.conversationList.searchHistory.title.recent')}
        </Button>
        {tagArr.length > 0 ? (
          <Button
            type="text"
            size="small"
            onClick={() => {
              setTagArr([]);
              setLocalSearchWords([]);
            }}
            style={{ color: '#B5B9BF' }}
          >
            {t('common.action.clear')}
          </Button>
        ) : null}
      </div>
      <div className={style.recentSearchTags}>
        {tagArr.map((t) => {
          const word = typeof t === 'string' ? t : t.word;

          return (
            <Tag
              key={word}
              className="max-w-full overflow-hidden text-ellipsis"
              title={word}
              onClick={() => doSearch(t)}
            >
              {word}
            </Tag>
          );
        })}
      </div>
      {tagArr.length === 0 ? (
        <Empty description={t('scene.chatWorkspace.conversationList.searchHistory.empty.none')} />
      ) : null}
    </div>
  );
}
